export const GENERIC_MESSAGES = {
  required: 'Seleccione un valor',
  dateRequired: 'Seleccione un período',
  genericError: 'Ha ocurrido un error, por favor vuelva a intentarlo.',
  authenticationError: 'Su sesión ha expirado. Inicie sesión para continuar.',
};

export const CARD_ERRORS = {
  cardNumberRequired: 'Debe ingresar un Nro. de tarjeta para poder realizar la consulta',
  cardNumberInvalid: 'El número de tarjeta introducido no es válido',
};

export const ACCOUNT_ERRORS = {
  accountRequired: 'Introduzca un número de cuenta',
  accountInvalid:
    'Número de cuenta inválido, por favor ingrese un valor numérico de entre 8 y 10 dígitos',
};

export const RECOVERY_ERRORS = {
  usernameRequired: 'Por favor ingrese un valor en el campo Código de Usuario.',
  cuitInvalid: 'El CUIT no es válido.',
  cuitRequired: 'Por favor ingrese un valor en el campo Nro. de CUIT de su empresa.',
  accountRequired: 'Por favor ingrese un valor en el campo Nro. de la cuenta raíz.',
  accountValidate: 'El número de cuenta raíz debe tener entre 8 y 10 dígitos numéricos.',
  cardTypeSelect: 'Por favor seleccione al menos un tipo de tarjeta.',
};

export const COST_CENTRE_ERRORS = {
  originCostCentreRequired: 'Seleccione un centro de costo origen',
  destinyCostCentreRequired: 'Seleccione un centro de costo destino',
};

export const DISTRIBUTION_ERRORS = {
  amountExceedsMax: 'El monto a distribuir supera al monto disponible de la cuenta',
  amountBelowMin: 'El monto ingresado debe ser mayor a cero',
  finalAmountIsZero:
    'Se debe realizar la transferencia a por lo menos una cuenta',
  childrenDontBelongToParent:
    'Los centros de costo a los que intentó hacer distribución no pertenecen al centro de costo padre',
  parentNotAssociated: 'El centro de costo no pertenece a su organización',
  allDataRequired: 'Introduzca ambos rangos para realizar la búsqueda',
  yearError: 'El año de inicio de búsqueda supera al año actual',
  monthError: 'La fecha seleccionada es superior al período actual',
};

export const GENERIC_DATE_ERRORS = {
  selectDateRequired: (
    <span className="errorSpan">Seleccione una fecha para su búsqueda primero.</span>
  ),
};

export const SEND_EMAIL_CONFIRMATION = {
  confirm: 'Correo enviado satisfactoriamente, expira en 10 minutos.',
  error:
    'No ha sido posible realizar el envio del correo, por favor intente mas tarde.',
  warning: 'La solicitud ya fue enviada, espere 10 minutos para volver a intentarlo.',
};
